import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(({
  className,
  ...props
}, ref) => (
  <select className={cn("sqk-select", className)} ref={ref} {...props} />
));
Select.displayName = "Select";
